import AScene from "../../library/ExtendedObjects/AScene.js";
import ShadowItem from "./ShadowItem.js";
import gameData from "../../gameData.js";
import TransitionBushes from "./TransitionBushes.js";
import ABCyaLib from '@abcya/abcya_lib';
import { Audio, Text } from "@abcya/abcya_phaser";
import FontKeys from "../../FontKeys.js";

export default class Intro extends AScene
{
    static get KEY() { return 'Intro'; }
    
    constructor()
    {
        super("Intro");
    }

    create()
    {

        this.addImage(this.mid.x, this.mid.y, "Background");

        const config = ABCyaLib.Environment.instance.gameConfig;

        this.plants = [];
        this.plants.push(new ShadowItem(this, 0, 15, .45, "Clover", 3, 10));
        this.plants.push(new ShadowItem(this, 350, 110, .45, "Clover", 3, 10));
        this.plants.push(new ShadowItem(this, this.size.width - 20, 420, .45, "Clover", 3, 10));
        this.plants.push(new ShadowItem(this, this.size.width - 100, 470, .45, "Clover", 3, 10));
        this.plants.push(new ShadowItem(this, this.mid.x - 100, this.size.height, .45, "Clover", 3, 10));
        this.plants.push(new ShadowItem(this, 0, 200, .45, "Flower", 3, 10));
        this.plants.push(new ShadowItem(this, 70, 270, .45, "Flower", 3, 10));
        this.plants.push(new ShadowItem(this, this.size.width - 30, this.size.height - 30, .45, "Flower", 3, 10));

        for (let i = 0; i < this.plants.length; i++) {
            this.plants[i].scale = 0;
            this.plants[i].angle = 90;
        }
        this.addDelay(800, ()=>{
            let plantTween_Duration = 1200;
            for (let i = 0; i < this.plants.length; i++) {
                this.addTween(this.plants[i], plantTween_Duration, { scale: Math.random() * .4 + .8, angle: 0, delay: Math.random() * 1200 }, "Back");
            }
            this.addDelay(plantTween_Duration, () => {
                for (let i = 0; i < this.plants.length; i++) {
                    this.wiggle(this.plants[i], 5, 0, Math.random() * 2000 + 2000);
                }
            });
        });

        this.tongue = this.addImage(-127, 100, "Tongue");
        this.snakeHead = new ShadowItem(this, 300, 32, .7, "Head", 0, 20, 0, 1, 1, this.tongue);
        this.leftEye = this.addImage(-159, 21, "LeftEye", this.snakeHead);
        this.rightEye = this.addImage(-43, 53, "RightEye", this.snakeHead);
        this.body = new ShadowItem(this, this.mid.x + 20, this.mid.y - 4, .7, "Body", 0, 45);
        this.tail = new ShadowItem(this, this.size.width + 10, 540, .7, "Tail", 0, 15);

        this.wiggle(this.snakeHead, -6, 0, 6000);
        this.wiggle(this.tail, -7, 0, 5000);
        this.blink();
        this.flickTongue();

        this.curButton = null;
        
        this.mainBoard = this.add.container(this.mid.x, this.mid.y);
        this.mainBoard_Bg = this.addImage(0, 0, "titleboard", this.mainBoard);

        if(config.subtitle !== null) {
          this.mainBoard_Bg.setFrame('title_background');
          this.addImage(0, -24, 'title_divider', this.mainBoard);
          this.addImage(0, -94, config.title, this.mainBoard);
          gameData.units = config.units;
          gameData.curGameType = config.gameType;
          Text.addText(this.mainBoard_Bg.getCenter().x, 54, 56, 0x663428, FontKeys._balooregular, config.subtitle, this.mainBoard);
        }

        else {

          this.mainBoard_Instructions = this.addText(0, 0, "Select a Game Mode:", 30, null, 1, this.mainBoard);
          this.mainBoard_Instructions.tint = 0xFFFEE0;

        this.mainBoard_CountButton = this.addButton(155, 83, "BTN_countOff", {tintOnDown: 0xaaaaaa}, ()=>{
            if(this.btnSound) this.btnSound.stop();
            this.btnSound = this.playSound("count_and_write", 1, false, false, Audio.LOCALIZATION_AUDIO_SPRITE);
            this.setSelectUnits("COUNT");
        }, this.mainBoard);
        this.mainBoard_ListenButton = this.addButton(0, 83, "BTN_listenOff", {tintOnDown: 0xaaaaaa}, ()=>{
            if(this.btnSound) this.btnSound.stop();
            this.btnSound = this.playSound("listen_and_make", 1, false, false, Audio.LOCALIZATION_AUDIO_SPRITE);
            this.setSelectUnits("LISTEN");
        }, this.mainBoard);
        this.mainBoard_ReadButton = this.addButton(-155, 83, "BTN_readOff", {tintOnDown: 0xaaaaaa}, ()=>{
            if(this.btnSound) this.btnSound.stop();
            this.btnSound = this.playSound("read_and_make", 1, false, false, Audio.LOCALIZATION_AUDIO_SPRITE);
            this.setSelectUnits("READ");
        }, this.mainBoard);

        this.mainBoard_Hundreds = this.addButton(155, 83, "hundredsOff", {tintOnDown: 0xaaaaaa}, ()=>{
            this.btnSound = this.playSound("hundreds", 1, false, false, Audio.LOCALIZATION_AUDIO_SPRITE);
            this.setButton(this.mainBoard_Hundreds, 100);
        }, this.mainBoard);
        this.mainBoard_TensButton = this.addButton(0, 83, "tensOff", {tintOnDown: 0xaaaaaa}, ()=>{
            this.btnSound = this.playSound("tens", 1, false, false, Audio.LOCALIZATION_AUDIO_SPRITE);
            this.setButton(this.mainBoard_TensButton, 10);
        }, this.mainBoard);
        this.mainBoard_OnesButton = this.addButton(-155, 83, "onesOff", {tintOnDown: 0xaaaaaa}, ()=>{
            this.btnSound = this.playSound("ones", 1, false, false, Audio.LOCALIZATION_AUDIO_SPRITE);
            this.setButton(this.mainBoard_OnesButton, 1);
        }, this.mainBoard);

        this.mainBoard_OnesButton.alpha = 0;
        this.mainBoard_TensButton.alpha = 0;
        this.mainBoard_Hundreds.alpha = 0;
      }

        this.mainBoard.setScale(1.2);
        this.mainBoard.alpha = 0;
        this.mainBoard.setDepth(3);
        this.addTween(this.mainBoard, 500, {alpha: 1, delay: 500});
        const boardTween = this.addTween(this.mainBoard, 1000, {scaleX: 1, scaleY: 1, delay: 500}, "Bounce");

        if (config.subtitle !== null) {
          boardTween.on(Phaser.Tweens.Events.TWEEN_COMPLETE, ()=>{
            this.addTween(this.goButton, 500, {alpha: 1, scaleX: 1, scaleY: 1}, "Back");
            // this.addTween(this.goButton, 300, {alpha: 0, scaleX: 1.2, scaleY: 1.2});
          });
        }

        this.leaves = [];
        this.leaves.push(new ShadowItem(this, -150, 400, .3, "leaf2", 3, 50, -14, -1, 1));
        this.leaves.push(new ShadowItem(this, -70, 740, .3, "leaf1", 3, 50, -55, -1.2, 1.2));
        this.leaves.push(new ShadowItem(this, 860, 950, .3, "leaf2", 3, 50, -110, -1.2, -1.2));
        this.leaves.push(new ShadowItem(this, 1100, 62, .3, "leaf2", 3, 50, 0, 1.1, 1.1));
        this.leaves.push(new ShadowItem(this, 1100, 145, .3, "leaf1", 3, 50, -30, 1.1, 1.1));
        this.leaves.push(new ShadowItem(this, 700, -220, .3, "leaf2", 3, 50, -50, 1.1, 1.1));

        for(let i = 0; i < this.leaves.length; i++)
        {
            this.leaves[i].setDepth(4);
            this.wiggle(this.leaves[i], this.leaves[i].angle + 3, this.leaves[i].angle - 3, Math.random() * 2000 + 4000);
        }

        this.backButton = this.addButton(this.mid.x, this.mid.y + 290, "back_unselected", {frameOnDown: "back_selected"}, ()=>{
            this.setSelectGameMode();
        });
        this.backButton.setScale(1.2);
        this.backButton.alpha = 0;

        this.goButton = this.addButton(this.mid.x + 80, this.mid.y + 290, "BTN_goOff", {frameOnDown: "BTN_goOn"}, ()=>{
            this.addTween(this.introSound, 200, {volume: 0});
            this.transitionBushes.transitionIn("Game");
        });
        if (config.subtitle) {
          this.goButton.x -= 80;
        }
        this.goButton.setScale(1.2);
        this.goButton.alpha = 0;

        this.transitionBushes = new TransitionBushes(this);

        this.introSound = this.playSound("base_ten_fun_jingle");
        if (config.subtitle === null){
          this.playSound("base_ten_fun_title_vo", 1, false, false, Audio.LOCALIZATION_AUDIO_SPRITE);
        }
    }

    setSelectGameMode()
    {
        this.killTween(this.backButton);
        this.killTween(this.mainBoard);
        this.killTween(this.goButton);

        this.addTween(this.mainBoard, 250, { scaleX: 0, scaleY: 1.2 }, Phaser.Math.Easing.Sine.In, () => {
            this.mainBoard_Instructions.text = "Select a Game Mode:";

            this.mainBoard_ReadButton.alpha = 1;
            this.mainBoard_ListenButton.alpha = 1;
            this.mainBoard_CountButton.alpha = 1;

            this.mainBoard_OnesButton.alpha = 0;
            this.mainBoard_TensButton.alpha = 0;
            this.mainBoard_Hundreds.alpha = 0;
            this.addTween(this.mainBoard, 500, { scaleX: 1, scaleY: 1 }, "Back", () => {

            });
        });

        this.setButton(null);

        this.addTween(this.backButton, 300, {alpha: 0, scaleX: 1.2, scaleY: 1.2});
        this.addTween(this.goButton, 300, {alpha: 0, scaleX: 1.2, scaleY: 1.2});
    }

    setSelectUnits(gameType)
    {
        this.killTween(this.backButton);
        this.killTween(this.mainBoard);
        this.killTween(this.goButton);

        gameData.curGameType = gameType;

        this.addTween(this.mainBoard, 250, { scaleX: 0, scaleY: 1.2 }, Phaser.Math.Easing.Sine.In, () => {
            this.selectUnitsDelay = this.addDelay(this.btnSound.duration * 1000, ()=>{ this.btnSound = this.playSound("select_units", 1, false, false, Audio.LOCALIZATION_AUDIO_SPRITE); });
            this.mainBoard_Instructions.text = "Select Units:";
            

            this.mainBoard_ReadButton.alpha = 0;
            this.mainBoard_ListenButton.alpha = 0;
            this.mainBoard_CountButton.alpha = 0;

            this.mainBoard_OnesButton.alpha = 1;
            this.mainBoard_TensButton.alpha = 1;
            this.mainBoard_Hundreds.alpha = 1;
            this.addTween(this.mainBoard, 500, { scaleX: 1, scaleY: 1 }, "Back", () => {

            });
        });

        this.backButton.x = this.mid.x;
        this.addTween(this.backButton, 500, {alpha: 1, scaleX: 1, scaleY: 1, delay: 750}, "Back");
    }

    setButton(button, units)
    {
        if(this.curButton == button) return;
        this.time.removeAllEvents();
        if(this.curButton != null)
        {
            let frameName = this.curButton.frame.name;
            let offFrameName = frameName.slice(0, frameName.length - 2) + "Off";
            this.curButton.setFrame(offFrameName, false, false);
        }
        else if(button)
        {
            this.addTween(this.goButton, 500, {alpha: 1, scaleX: 1, scaleY: 1}, "Back");
            this.addTween(this.backButton, 500, {x: this.mid.x - 80}, "Back");
        }

        this.curButton = button;

        if(!button) return;

        gameData.units = units;

        let frameName = button.frame.name;
        let onFrameName = frameName.slice(0, frameName.length - 3) + "On";
        button.setFrame(onFrameName, false, false);
    }

    flickTongue()
    {
        this.addDelay(Math.random() * 7000 + 3000, ()=>{
            this.addTween(this.tongue, 200, {x: -143, y: 150}, Phaser.Math.Easing.Sine.Out, ()=>{
                this.addTween(this.tongue, 100, {angle: -10, scaleX: .8, scaleY: .9}, Phaser.Math.Easing.Sine.Out, ()=>{
                    this.addTween(this.tongue, 100, {angle: 0, scaleX: 1, scaleY: 1}, Phaser.Math.Easing.Sine.Out, ()=>{
                        this.addTween(this.tongue, 100, {angle: -10, scaleX: .8, scaleY: .9}, Phaser.Math.Easing.Sine.Out, ()=>{
                            this.addTween(this.tongue, 100, {angle: 0, scaleX: 1, scaleY: 1}, Phaser.Math.Easing.Sine.Out, ()=>{
                                this.addTween(this.tongue, 200, {x: -125, y: 100}); -127, 100
                                this.flickTongue();
                            });
                        }); 
                    });
                });
            });
        });
    }

    blink()
    {
        this.addDelay(Math.random() * 6000 + 3000, ()=>{
            this.leftEye.setFrame("LeftEye_Eyelid", false, false);
            this.rightEye.setFrame("RightEye_Eyelid", false, false);

            this.addDelay(200, ()=>{
                this.leftEye.setFrame("LeftEye", false, false);
                this.rightEye.setFrame("RightEye", false, false);
                this.blink();
            });
        });
    }

    wiggle(item, to, from, duration)
    {
        this.addTween(item, duration, {angle: to}, Phaser.Math.Easing.Sine.InOut, ()=>{
            this.wiggle(item, from, to, duration);
        });
    }
}